"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    toggleButtonClassNames: function() {
        return toggleButtonClassNames;
    },
    useToggleButtonStyles_unstable: function() {
        return useToggleButtonStyles_unstable;
    }
});
const _react = require("@griffel/react");
const _useButtonStylesstyles = require("../Button/useButtonStyles.styles");
const toggleButtonClassNames = {
    root: 'fui-ToggleButton',
    icon: 'fui-ToggleButton__icon'
};
const useRootCheckedStyles = /*#__PURE__*/ (0, _react.__styles)({
    base: {
        De3pzq: "f1nfm20t",
        g2u3we: "fj3muxo",
        h3c5rm: [
            "f1akhkt",
            "f1lxtadh"
        ],
        B9xav0g: "f1aperda",
        zhjwy3: [
            "f1lxtadh",
            "f1akhkt"
        ],
        sj55zd: "f14nttnl",
        B4j52fo: "f192inf7",
        Bekrc4i: [
            "f5tn483",
            "f1ojsxk5"
        ],
        Bn0qgzm: "f1vxd6vx",
        ibv6hh: [
            "f1ojsxk5",
            "f5tn483"
        ],
        D0sxk3: "fxoiby5",
        t6yez3: "f15q0o9g",
        Jwef8y: "f1knas48",
        Bgoe8wy: "fvcxoqz",
        Bwzppfd: [
            "f1ub3y4t",
            "f1m52nbi"
        ],
        oetu4i: "f1xlaoq0",
        gg5e9n: [
            "f1m52nbi",
            "f1ub3y4t"
        ],
        Bi91k9c: "feu1g3u",
        iro3zm: "f141de4g",
        b661bw: "f11v6sdu",
        Bk6r4ia: [
            "f9yn8i4",
            "f1ajwf28"
        ],
        B9zn80p: "f1uwu36w",
        Bpld233: [
            "f1ajwf28",
            "f9yn8i4"
        ],
        B2d53fq: "f9olfzr"
    },
    highContrast: {
        Bsw6fvg: "f1rirnrt",
        Bjwas2f: "f132fbg1",
        Bn1d65q: [
            "f1ene5x0",
            "fzbc999"
        ],
        Bxeuatn: "f6jgcol",
        n51gp8: [
            "fzbc999",
            "f1ene5x0"
        ],
        Bbusuzp: "f1lkg8j3",
        ycbfsm: "fkc42ay",
        Bqrx1nm: "fq7113v",
        pgvf35: "ff1wgvm",
        Bh7lczh: [
            "fiob0tu",
            "f1x4h75k"
        ],
        dpv3f4: "f1j6scgf",
        Bpnjhaq: [
            "f1x4h75k",
            "fiob0tu"
        ],
        ze5xyy: "f4xjyn1",
        g2kj27: "fbgcvur",
        Bf756sw: "f1ks1yx8",
        Bow2dr7: [
            "f1o6qegi",
            "fmxjhhp"
        ],
        Bvhedfk: "fcnxywj",
        Gye4lf: [
            "fmxjhhp",
            "f1o6qegi"
        ],
        pc6evw: "f9ddjv3",
        Btyszwp: "f1j4zkqc",
        B8jyv7h: [
            "f1ug3svw",
            "f10xfdm4"
        ],
        l9kbep: "f4xlnbu",
        By5cl00: [
            "f10xfdm4",
            "f1ug3svw"
        ],
        abbn9y: "f1jhcl7q",
        Bw5jppy: [
            "fokje0w",
            "fpctg2v"
        ],
        B0tp99d: "f1yfuj62",
        B55dcl7: [
            "fpctg2v",
            "fokje0w"
        ],
        G867l3: "fk75khc",
        gdbnj: [
            "f90nk7n",
            "f16eiqta"
        ],
        mxns5l: "fnz8tm1",
        o3nasb: [
            "f16eiqta",
            "f90nk7n"
        ],
        B7d2ofm: "fkom8lu"
    },
    outline: {
        De3pzq: "f1q9pm1r",
        g2u3we: "fj3muxo",
        h3c5rm: [
            "f1akhkt",
            "f1lxtadh"
        ],
        B9xav0g: "f1aperda",
        zhjwy3: [
            "f1lxtadh",
            "f1akhkt"
        ],
        B4j52fo: "fgx37oo",
        Bekrc4i: [
            "f130t4y6",
            "f1efpmoh"
        ],
        Bn0qgzm: "fv51ejd",
        ibv6hh: [
            "f1efpmoh",
            "f130t4y6"
        ],
        Jwef8y: "fjxutwb",
        iro3zm: "fwiml72",
        B8q5s1w: "fcaw57c",
        Bci5o5g: [
            "fpwd27e",
            "f1999bjr"
        ],
        n8qw10: "f1hi52o4",
        Bdrgwmp: [
            "f1999bjr",
            "fpwd27e"
        ]
    },
    primary: {
        De3pzq: "f8w4g0q",
        g2u3we: "f1p3nwhy",
        h3c5rm: [
            "f11589ue",
            "f1pdflbu"
        ],
        B9xav0g: "f1q5o8ev",
        zhjwy3: [
            "f1pdflbu",
            "f11589ue"
        ],
        sj55zd: "f1phragk",
        Jwef8y: "f15wkkf3",
        Bgoe8wy: "f1s2uweq",
        Bwzppfd: [
            "fr80ssc",
            "fecsdlb"
        ],
        oetu4i: "f1ukrpxl",
        gg5e9n: [
            "fecsdlb",
            "fr80ssc"
        ],
        Bi91k9c: "f1rq72xc",
        iro3zm: "fnp9lpt",
        b661bw: "f1h0usnq",
        Bk6r4ia: [
            "fs4ktlq",
            "fx2bmrt"
        ],
        B9zn80p: "f16h9ulv",
        Bpld233: [
            "fx2bmrt",
            "fs4ktlq"
        ],
        B2d53fq: "f1d6v5y2"
    },
    secondary: {},
    subtle: {
        De3pzq: "fq5gl1p",
        g2u3we: "f1p3nwhy",
        h3c5rm: [
            "f11589ue",
            "f1pdflbu"
        ],
        B9xav0g: "f1q5o8ev",
        zhjwy3: [
            "f1pdflbu",
            "f11589ue"
        ],
        sj55zd: "f1eryozh",
        Jwef8y: "f1t94bn6",
        Bgoe8wy: "f1s2uweq",
        Bwzppfd: [
            "fr80ssc",
            "fecsdlb"
        ],
        oetu4i: "f1ukrpxl",
        gg5e9n: [
            "fecsdlb",
            "fr80ssc"
        ],
        Bi91k9c: "fnwyq0v",
        iro3zm: "fsv2rcd",
        b661bw: "f1h0usnq",
        Bk6r4ia: [
            "fs4ktlq",
            "fx2bmrt"
        ],
        B9zn80p: "f16h9ulv",
        Bpld233: [
            "fx2bmrt",
            "fs4ktlq"
        ],
        B2d53fq: "f1omzyqd"
    },
    transparent: {
        De3pzq: "f1q9pm1r",
        g2u3we: "f1p3nwhy",
        h3c5rm: [
            "f11589ue",
            "f1pdflbu"
        ],
        B9xav0g: "f1q5o8ev",
        zhjwy3: [
            "f1pdflbu",
            "f11589ue"
        ],
        sj55zd: "f1qj7y59",
        Jwef8y: "fjxutwb",
        Bgoe8wy: "f1s2uweq",
        Bwzppfd: [
            "fr80ssc",
            "fecsdlb"
        ],
        oetu4i: "f1ukrpxl",
        gg5e9n: [
            "fecsdlb",
            "fr80ssc"
        ],
        Bi91k9c: "f139oj5f",
        iro3zm: "fwiml72",
        b661bw: "f1h0usnq",
        Bk6r4ia: [
            "fs4ktlq",
            "fx2bmrt"
        ],
        B9zn80p: "f16h9ulv",
        Bpld233: [
            "fx2bmrt",
            "fs4ktlq"
        ],
        B2d53fq: "f1fg1p5m"
    }
}, {
    d: [
        ".f1nfm20t{background-color:var(--colorNeutralBackground1Selected);}",
        ".fj3muxo{border-top-color:var(--colorNeutralStroke1);}",
        ".f1akhkt{border-right-color:var(--colorNeutralStroke1);}",
        ".f1lxtadh{border-left-color:var(--colorNeutralStroke1);}",
        ".f1aperda{border-bottom-color:var(--colorNeutralStroke1);}",
        ".f14nttnl{color:var(--colorNeutralForeground1Selected);}",
        ".f192inf7{border-top-width:var(--strokeWidthThin);}",
        ".f5tn483{border-right-width:var(--strokeWidthThin);}",
        ".f1ojsxk5{border-left-width:var(--strokeWidthThin);}",
        ".f1vxd6vx{border-bottom-width:var(--strokeWidthThin);}",
        ".fxoiby5 .fui-Icon-filled{display:inline;}",
        ".f15q0o9g .fui-Icon-regular{display:none;}",
        ".f1q9pm1r{background-color:var(--colorTransparentBackgroundSelected);}",
        ".fgx37oo{border-top-width:var(--strokeWidthThicker);}",
        ".f130t4y6{border-right-width:var(--strokeWidthThicker);}",
        ".f1efpmoh{border-left-width:var(--strokeWidthThicker);}",
        ".fv51ejd{border-bottom-width:var(--strokeWidthThicker);}",
        ".fcaw57c[data-fui-focus-visible]{border-top-color:var(--colorNeutralStroke1);}",
        ".fpwd27e[data-fui-focus-visible]{border-right-color:var(--colorNeutralStroke1);}",
        ".f1999bjr[data-fui-focus-visible]{border-left-color:var(--colorNeutralStroke1);}",
        ".f1hi52o4[data-fui-focus-visible]{border-bottom-color:var(--colorNeutralStroke1);}",
        ".f8w4g0q{background-color:var(--colorBrandBackgroundSelected);}",
        ".f1p3nwhy{border-top-color:transparent;}",
        ".f11589ue{border-right-color:transparent;}",
        ".f1pdflbu{border-left-color:transparent;}",
        ".f1q5o8ev{border-bottom-color:transparent;}",
        ".f1phragk{color:var(--colorNeutralForegroundOnBrand);}",
        ".fq5gl1p{background-color:var(--colorSubtleBackgroundSelected);}",
        ".f1eryozh{color:var(--colorNeutralForeground2Selected);}",
        ".f1qj7y59{color:var(--colorNeutralForeground2BrandSelected);}"
    ],
    h: [
        ".f1knas48:hover{background-color:var(--colorNeutralBackground1Hover);}",
        ".fvcxoqz:hover{border-top-color:var(--colorNeutralStroke1Hover);}",
        ".f1ub3y4t:hover{border-right-color:var(--colorNeutralStroke1Hover);}",
        ".f1m52nbi:hover{border-left-color:var(--colorNeutralStroke1Hover);}",
        ".f1xlaoq0:hover{border-bottom-color:var(--colorNeutralStroke1Hover);}",
        ".feu1g3u:hover{color:var(--colorNeutralForeground1Hover);}",
        ".f141de4g:hover:active{background-color:var(--colorNeutralBackground1Pressed);}",
        ".f11v6sdu:hover:active{border-top-color:var(--colorNeutralStroke1Pressed);}",
        ".f9yn8i4:hover:active{border-right-color:var(--colorNeutralStroke1Pressed);}",
        ".f1ajwf28:hover:active{border-left-color:var(--colorNeutralStroke1Pressed);}",
        ".f1uwu36w:hover:active{border-bottom-color:var(--colorNeutralStroke1Pressed);}",
        ".f9olfzr:hover:active{color:var(--colorNeutralForeground1Pressed);}",
        ".fjxutwb:hover{background-color:var(--colorTransparentBackgroundHover);}",
        ".fwiml72:hover:active{background-color:var(--colorTransparentBackgroundPressed);}",
        ".f15wkkf3:hover{background-color:var(--colorBrandBackgroundHover);}",
        ".f1s2uweq:hover{border-top-color:transparent;}",
        ".fr80ssc:hover{border-right-color:transparent;}",
        ".fecsdlb:hover{border-left-color:transparent;}",
        ".f1ukrpxl:hover{border-bottom-color:transparent;}",
        ".f1rq72xc:hover{color:var(--colorNeutralForegroundOnBrand);}",
        ".fnp9lpt:hover:active{background-color:var(--colorBrandBackgroundPressed);}",
        ".f1h0usnq:hover:active{border-top-color:transparent;}",
        ".fs4ktlq:hover:active{border-right-color:transparent;}",
        ".fx2bmrt:hover:active{border-left-color:transparent;}",
        ".f16h9ulv:hover:active{border-bottom-color:transparent;}",
        ".f1d6v5y2:hover:active{color:var(--colorNeutralForegroundOnBrand);}",
        ".f1t94bn6:hover{background-color:var(--colorSubtleBackgroundHover);}",
        ".fnwyq0v:hover{color:var(--colorNeutralForeground2Hover);}",
        ".fsv2rcd:hover:active{background-color:var(--colorSubtleBackgroundPressed);}",
        ".f1omzyqd:hover:active{color:var(--colorNeutralForeground2Pressed);}",
        ".f139oj5f:hover{color:var(--colorNeutralForeground2BrandHover);}",
        ".f1fg1p5m:hover:active{color:var(--colorNeutralForeground2BrandPressed);}"
    ],
    m: [
        [
            "@media (forced-colors: active){.f1rirnrt{background-color:Highlight;}}",
            {
                m: "(forced-colors: active)"
            }
        ],
        [
            "@media (forced-colors: active){.f132fbg1{border-top-color:Highlight;}}",
            {
                m: "(forced-colors: active)"
            }
        ],
        [
            "@media (forced-colors: active){.f1ene5x0{border-right-color:Highlight;}.fzbc999{border-left-color:Highlight;}}",
            {
                m: "(forced-colors: active)"
            }
        ],
        [
            "@media (forced-colors: active){.f6jgcol{border-bottom-color:Highlight;}}",
            {
                m: "(forced-colors: active)"
            }
        ],
        [
            "@media (forced-colors: active){.f1lkg8j3{color:HighlightText;}}",
            {
                m: "(forced-colors: active)"
            }
        ],
        [
            "@media (forced-colors: active){.fkc42ay{forced-color-adjust:none;}}",
            {
                m: "(forced-colors: active)"
            }
        ],
        [
            "@media (forced-colors: active){.fq7113v:hover{background-color:HighlightText;}}",
            {
                m: "(forced-colors: active)"
            }
        ],
        [
            "@media (forced-colors: active){.ff1wgvm:hover{border-top-color:Highlight;}}",
            {
                m: "(forced-colors: active)"
            }
        ],
        [
            "@media (forced-colors: active){.f1x4h75k:hover{border-left-color:Highlight;}.fiob0tu:hover{border-right-color:Highlight;}}",
            {
                m: "(forced-colors: active)"
            }
        ],
        [
            "@media (forced-colors: active){.f1j6scgf:hover{border-bottom-color:Highlight;}}",
            {
                m: "(forced-colors: active)"
            }
        ],
        [
            "@media (forced-colors: active){.f4xjyn1:hover{color:Highlight;}}",
            {
                m: "(forced-colors: active)"
            }
        ],
        [
            "@media (forced-colors: active){.fbgcvur:hover:active{background-color:HighlightText;}}",
            {
                m: "(forced-colors: active)"
            }
        ],
        [
            "@media (forced-colors: active){.f1ks1yx8:hover:active{border-top-color:Highlight;}}",
            {
                m: "(forced-colors: active)"
            }
        ],
        [
            "@media (forced-colors: active){.f1o6qegi:hover:active{border-right-color:Highlight;}.fmxjhhp:hover:active{border-left-color:Highlight;}}",
            {
                m: "(forced-colors: active)"
            }
        ],
        [
            "@media (forced-colors: active){.fcnxywj:hover:active{border-bottom-color:Highlight;}}",
            {
                m: "(forced-colors: active)"
            }
        ],
        [
            "@media (forced-colors: active){.f9ddjv3:hover:active{color:Highlight;}}",
            {
                m: "(forced-colors: active)"
            }
        ],
        [
            "@media (forced-colors: active){.f1j4zkqc:focus{border-top-width:1px;}}",
            {
                m: "(forced-colors: active)"
            }
        ],
        [
            "@media (forced-colors: active){.f10xfdm4:focus{border-left-width:1px;}.f1ug3svw:focus{border-right-width:1px;}}",
            {
                m: "(forced-colors: active)"
            }
        ],
        [
            "@media (forced-colors: active){.f4xlnbu:focus{border-bottom-width:1px;}}",
            {
                m: "(forced-colors: active)"
            }
        ],
        [
            "@media (forced-colors: active){.f1jhcl7q:focus{border-top-style:solid;}}",
            {
                m: "(forced-colors: active)"
            }
        ],
        [
            "@media (forced-colors: active){.fokje0w:focus{border-right-style:solid;}.fpctg2v:focus{border-left-style:solid;}}",
            {
                m: "(forced-colors: active)"
            }
        ],
        [
            "@media (forced-colors: active){.f1yfuj62:focus{border-bottom-style:solid;}}",
            {
                m: "(forced-colors: active)"
            }
        ],
        [
            "@media (forced-colors: active){.fk75khc:focus{border-top-color:HighlightText;}}",
            {
                m: "(forced-colors: active)"
            }
        ],
        [
            "@media (forced-colors: active){.f16eiqta:focus{border-left-color:HighlightText;}.f90nk7n:focus{border-right-color:HighlightText;}}",
            {
                m: "(forced-colors: active)"
            }
        ],
        [
            "@media (forced-colors: active){.fnz8tm1:focus{border-bottom-color:HighlightText;}}",
            {
                m: "(forced-colors: active)"
            }
        ],
        [
            "@media (forced-colors: active){.fkom8lu:focus{outline-color:Highlight;}}",
            {
                m: "(forced-colors: active)"
            }
        ]
    ]
});
const useRootDisabledStyles = /*#__PURE__*/ (0, _react.__styles)({
    base: {
        De3pzq: "f1bg9a2p",
        g2u3we: "f1jj8ep1",
        h3c5rm: [
            "f15xbau",
            "fy0fskl"
        ],
        B9xav0g: "f4ikngz",
        zhjwy3: [
            "fy0fskl",
            "f15xbau"
        ],
        sj55zd: "f1s2aq7o",
        Jwef8y: "f1falr9n",
        Bgoe8wy: "f12mpcsy",
        Bwzppfd: [
            "f1gwvigk",
            "f18rmfxp"
        ],
        oetu4i: "f1jnshp0",
        gg5e9n: [
            "f18rmfxp",
            "f1gwvigk"
        ],
        Bi91k9c: "fvgxktp",
        iro3zm: "f1t6o4dc",
        b661bw: "f10ztigi",
        Bk6r4ia: [
            "f1ft5sdu",
            "f1gzf82w"
        ],
        B9zn80p: "f12zbtn2",
        Bpld233: [
            "f1gzf82w",
            "f1ft5sdu"
        ],
        B2d53fq: "fcvwxyo"
    },
    outline: {},
    primary: {
        g2u3we: "f1p3nwhy",
        h3c5rm: [
            "f11589ue",
            "f1pdflbu"
        ],
        B9xav0g: "f1q5o8ev",
        zhjwy3: [
            "f1pdflbu",
            "f11589ue"
        ],
        Bgoe8wy: "f1s2uweq",
        Bwzppfd: [
            "fr80ssc",
            "fecsdlb"
        ],
        oetu4i: "f1ukrpxl",
        gg5e9n: [
            "fecsdlb",
            "fr80ssc"
        ],
        b661bw: "f1h0usnq",
        Bk6r4ia: [
            "fs4ktlq",
            "fx2bmrt"
        ],
        B9zn80p: "f16h9ulv",
        Bpld233: [
            "fx2bmrt",
            "fs4ktlq"
        ]
    },
    secondary: {},
    subtle: {
        De3pzq: "f1c21dwh",
        g2u3we: "f1p3nwhy",
        h3c5rm: [
            "f11589ue",
            "f1pdflbu"
        ],
        B9xav0g: "f1q5o8ev",
        zhjwy3: [
            "f1pdflbu",
            "f11589ue"
        ],
        Jwef8y: "fjxutwb",
        Bgoe8wy: "f1s2uweq",
        Bwzppfd: [
            "fr80ssc",
            "fecsdlb"
        ],
        oetu4i: "f1ukrpxl",
        gg5e9n: [
            "fecsdlb",
            "fr80ssc"
        ],
        iro3zm: "fwiml72",
        b661bw: "f1h0usnq",
        Bk6r4ia: [
            "fs4ktlq",
            "fx2bmrt"
        ],
        B9zn80p: "f16h9ulv",
        Bpld233: [
            "fx2bmrt",
            "fs4ktlq"
        ]
    },
    transparent: {
        De3pzq: "f1c21dwh",
        g2u3we: "f1p3nwhy",
        h3c5rm: [
            "f11589ue",
            "f1pdflbu"
        ],
        B9xav0g: "f1q5o8ev",
        zhjwy3: [
            "f1pdflbu",
            "f11589ue"
        ],
        Jwef8y: "fjxutwb",
        Bgoe8wy: "f1s2uweq",
        Bwzppfd: [
            "fr80ssc",
            "fecsdlb"
        ],
        oetu4i: "f1ukrpxl",
        gg5e9n: [
            "fecsdlb",
            "fr80ssc"
        ],
        iro3zm: "fwiml72",
        b661bw: "f1h0usnq",
        Bk6r4ia: [
            "fs4ktlq",
            "fx2bmrt"
        ],
        B9zn80p: "f16h9ulv",
        Bpld233: [
            "fx2bmrt",
            "fs4ktlq"
        ]
    }
}, {
    d: [
        ".f1bg9a2p{background-color:var(--colorNeutralBackgroundDisabled);}",
        ".f1jj8ep1{border-top-color:var(--colorNeutralStrokeDisabled);}",
        ".f15xbau{border-right-color:var(--colorNeutralStrokeDisabled);}",
        ".fy0fskl{border-left-color:var(--colorNeutralStrokeDisabled);}",
        ".f4ikngz{border-bottom-color:var(--colorNeutralStrokeDisabled);}",
        ".f1s2aq7o{color:var(--colorNeutralForegroundDisabled);}",
        ".f1p3nwhy{border-top-color:transparent;}",
        ".f11589ue{border-right-color:transparent;}",
        ".f1pdflbu{border-left-color:transparent;}",
        ".f1q5o8ev{border-bottom-color:transparent;}",
        ".f1c21dwh{background-color:var(--colorTransparentBackground);}"
    ],
    h: [
        ".f1falr9n:hover{background-color:var(--colorNeutralBackgroundDisabled);}",
        ".f12mpcsy:hover{border-top-color:var(--colorNeutralStrokeDisabled);}",
        ".f1gwvigk:hover{border-right-color:var(--colorNeutralStrokeDisabled);}",
        ".f18rmfxp:hover{border-left-color:var(--colorNeutralStrokeDisabled);}",
        ".f1jnshp0:hover{border-bottom-color:var(--colorNeutralStrokeDisabled);}",
        ".fvgxktp:hover{color:var(--colorNeutralForegroundDisabled);}",
        ".f1t6o4dc:hover:active{background-color:var(--colorNeutralBackgroundDisabled);}",
        ".f10ztigi:hover:active{border-top-color:var(--colorNeutralStrokeDisabled);}",
        ".f1ft5sdu:hover:active{border-right-color:var(--colorNeutralStrokeDisabled);}",
        ".f1gzf82w:hover:active{border-left-color:var(--colorNeutralStrokeDisabled);}",
        ".f12zbtn2:hover:active{border-bottom-color:var(--colorNeutralStrokeDisabled);}",
        ".fcvwxyo:hover:active{color:var(--colorNeutralForegroundDisabled);}",
        ".f1s2uweq:hover{border-top-color:transparent;}",
        ".fr80ssc:hover{border-right-color:transparent;}",
        ".fecsdlb:hover{border-left-color:transparent;}",
        ".f1ukrpxl:hover{border-bottom-color:transparent;}",
        ".f1h0usnq:hover:active{border-top-color:transparent;}",
        ".fs4ktlq:hover:active{border-right-color:transparent;}",
        ".fx2bmrt:hover:active{border-left-color:transparent;}",
        ".f16h9ulv:hover:active{border-bottom-color:transparent;}",
        ".fjxutwb:hover{background-color:var(--colorTransparentBackgroundHover);}",
        ".fwiml72:hover:active{background-color:var(--colorTransparentBackgroundPressed);}"
    ]
});
const useIconCheckedStyles = /*#__PURE__*/ (0, _react.__styles)({
    subtleOrTransparent: {
        sj55zd: "f1qj7y59"
    },
    highContrast: {
        ycbfsm: "fg4l7m0"
    }
}, {
    d: [
        ".f1qj7y59{color:var(--colorNeutralForeground2BrandSelected);}"
    ],
    m: [
        [
            "@media (forced-colors: active){.fg4l7m0{forced-color-adjust:auto;}}",
            {
                m: "(forced-colors: active)"
            }
        ]
    ]
});
const usePrimaryHighContrastStyles = /*#__PURE__*/ (0, _react.__styles)({
    base: {
        Bsw6fvg: "f4lkoma",
        Bjwas2f: "f1bauw5b",
        Bn1d65q: [
            "fbpknfk",
            "fedl69w"
        ],
        Bxeuatn: "f15s25nd",
        n51gp8: [
            "fedl69w",
            "fbpknfk"
        ],
        Bbusuzp: "f1e4kh5",
        ycbfsm: "fg4l7m0"
    },
    disabled: {
        Bjwas2f: "fg455y9",
        Bn1d65q: [
            "f1rvyvqg",
            "f14g86mu"
        ],
        Bxeuatn: "f1cwzwz",
        n51gp8: [
            "f14g86mu",
            "f1rvyvqg"
        ],
        Bbusuzp: "f1dcs8yz",
        G867l3: "fjwq6ea",
        gdbnj: [
            "f1lr3nhc",
            "f1mbxvi6"
        ],
        mxns5l: "fn5gmvv",
        o3nasb: [
            "f1mbxvi6",
            "f1lr3nhc"
        ]
    }
}, {
    m: [
        [
            "@media (forced-colors: active){.f4lkoma{background-color:ButtonFace;}}",
            {
                m: "(forced-colors: active)"
            }
        ],
        [
            "@media (forced-colors: active){.f1bauw5b{border-top-color:ButtonBorder;}}",
            {
                m: "(forced-colors: active)"
            }
        ],
        [
            "@media (forced-colors: active){.fbpknfk{border-right-color:ButtonBorder;}.fedl69w{border-left-color:ButtonBorder;}}",
            {
                m: "(forced-colors: active)"
            }
        ],
        [
            "@media (forced-colors: active){.f15s25nd{border-bottom-color:ButtonBorder;}}",
            {
                m: "(forced-colors: active)"
            }
        ],
        [
            "@media (forced-colors: active){.f1e4kh5{color:ButtonText;}}",
            {
                m: "(forced-colors: active)"
            }
        ],
        [
            "@media (forced-colors: active){.fg4l7m0{forced-color-adjust:auto;}}",
            {
                m: "(forced-colors: active)"
            }
        ],
        [
            "@media (forced-colors: active){.fg455y9{border-top-color:GrayText;}}",
            {
                m: "(forced-colors: active)"
            }
        ],
        [
            "@media (forced-colors: active){.f14g86mu{border-left-color:GrayText;}.f1rvyvqg{border-right-color:GrayText;}}",
            {
                m: "(forced-colors: active)"
            }
        ],
        [
            "@media (forced-colors: active){.f1cwzwz{border-bottom-color:GrayText;}}",
            {
                m: "(forced-colors: active)"
            }
        ],
        [
            "@media (forced-colors: active){.f1dcs8yz{color:GrayText;}}",
            {
                m: "(forced-colors: active)"
            }
        ],
        [
            "@media (forced-colors: active){.fjwq6ea:focus{border-top-color:GrayText;}}",
            {
                m: "(forced-colors: active)"
            }
        ],
        [
            "@media (forced-colors: active){.f1lr3nhc:focus{border-right-color:GrayText;}.f1mbxvi6:focus{border-left-color:GrayText;}}",
            {
                m: "(forced-colors: active)"
            }
        ],
        [
            "@media (forced-colors: active){.fn5gmvv:focus{border-bottom-color:GrayText;}}",
            {
                m: "(forced-colors: active)"
            }
        ]
    ]
});
const useToggleButtonStyles_unstable = (state)=>{
    const rootCheckedStyles = useRootCheckedStyles();
    const rootDisabledStyles = useRootDisabledStyles();
    const iconCheckedStyles = useIconCheckedStyles();
    const primaryHighContrastStyles = usePrimaryHighContrastStyles();
    const { appearance, checked, disabled, disabledFocusable } = state;
    state.root.className = (0, _react.mergeClasses)(toggleButtonClassNames.root, // Primary high contrast styles
    appearance === 'primary' && primaryHighContrastStyles.base, appearance === 'primary' && (disabled || disabledFocusable) && primaryHighContrastStyles.disabled, // Checked styles
    checked && rootCheckedStyles.base, checked && rootCheckedStyles.highContrast, appearance && checked && rootCheckedStyles[appearance], // Disabled styles
    (disabled || disabledFocusable) && rootDisabledStyles.base, appearance && (disabled || disabledFocusable) && rootDisabledStyles[appearance], // User provided class name
    state.root.className);
    if (state.icon) {
        state.icon.className = (0, _react.mergeClasses)(toggleButtonClassNames.icon, (appearance === 'subtle' || appearance === 'transparent') && iconCheckedStyles.subtleOrTransparent && iconCheckedStyles.highContrast, state.icon.className);
    }
    (0, _useButtonStylesstyles.useButtonStyles_unstable)(state);
    return state;
}; //# sourceMappingURL=useToggleButtonStyles.styles.js.map
